import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";

import "./theme.scss"
import "./style/font_icon/iconfont.css";
// import "./rem/rem.js";
import "lib-flexible";
import BaiduMap from "vue-baidu-map";
import { VueJsonp } from "vue-jsonp";


Vue.prototype.GLOBAL = "/api/system/user/profile/housePic";
// 订单socket地址
Vue.prototype.socketUrl='wss://test.youjiaminsu.cn/wss';
// 消息socket 地址
Vue.prototype.socketMsgUrl='wss://test.youjiaminsu.cn/wss';
// Vue.prototype.socketUrl= 'ws://192.168.0.35:8808/api/Websocket/1';//订单通知socketUrl
Vue.use(VueJsonp);
Vue.use(BaiduMap, {
  ak: "gYOBOyROwCVTPTZavwZ6GumDClyRSjhB"
});
Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
